import { ToggleField } from '@/components/ui/switch';

/**
 * "Confiar neste dispositivo" (ADR-026), no código do 2FA e na configuração obrigatória.
 * Some quando o servidor desliga o recurso (`days` = 0). A explicação diz o que continua valendo
 * — sem ela, parece que o login inteiro fica dispensado.
 */
export function TrustDeviceField({
  days,
  checked,
  onCheckedChange,
}: {
  days: number | undefined;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}) {
  if (!days) return null;
  return (
    <ToggleField
      label={`Confiar neste dispositivo por ${days} dias`}
      description="Neste navegador, o código não será pedido de novo. A senha continua obrigatória. Não use em computador compartilhado."
      checked={checked}
      onCheckedChange={onCheckedChange}
    />
  );
}
